webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(39);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  searchResults: [],
  total: 0,
  searchTearm: '',
  nextLink: 1,
  offset: 0,
  searchType: 'album',
  noResults: false,
  limit: 20,
  tracks: [],
  bio: [],
  similarArtist: [],
  bioContent: '',
  bioImg: ''
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */]
}));

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/default.862c7ad.png";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(62),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(49)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(60),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(48)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(59),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(context, payload) {
    context.commit('search', payload);
  },
  artistBio: function artistBio(context, payload) {
    context.commit('artistBio', payload);
  },
  setSearchType: function setSearchType(context, payload) {
    context.commit('searchType', payload);
  },
  getTracks: function getTracks(context, payload) {
    context.commit('trackList', payload);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Intro__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Intro___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Intro__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Bio__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Bio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Bio__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Intro___default.a
}, {
  path: '/bio/:id',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Bio___default.a
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__data_store__["a" /* default */],
  router: router,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__components_App___default.a);
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
__webpack_require__(46).polyfill();




var API_KEY = 'fc9fb92aa0f29e6d43f570f02222e1a1';
var URL = 'https://ws.audioscrobbler.com/2.0/';
var setActive = function setActive(v) {
  v.active = false;
  return v;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(state, payload) {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(URL + '?' + state.searchType + '=' + payload.tearm, {
      params: {
        method: state.searchType + '.search',
        page: state.nextLink,
        api_key: API_KEY,
        limit: 20,
        format: 'json'
      }
    }).then(function (response) {
      var data = response.data;
      var results = data.results[state.searchType + 'matches'][state.searchType];
      var hasMoreResults = data.results['opensearch:totalResults'] - data.results['opensearch:itemsPerPage'] - data.results['opensearch:startIndex'];
      __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(results, setActive);

      if (payload.type !== 'search') {
        state.offset = data.results['opensearch:startIndex'];
        state.searchResults = state.searchResults.concat(results);
        state.nextLink = hasMoreResults > 0 ? ++state.nextLink : false;
      } else {
        state.offset = 0;
        state.searchResults = results;
        state.nextLink = hasMoreResults > 0 ? 2 : false;
      }

      state.total = state.searchResults.length;
      state.searchTearm = payload.tearm;
      state.noResults = state.total <= 0;
    }, function (response) {
      _this.error = response.data;
    });
  },
  searchType: function searchType(state, payload) {
    state.searchType = payload.val;
    state.searchResults = [];
    state.nextLink = 1;
    state.total = null;
  },
  trackList: function trackList(state, payload) {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('' + URL, {
      params: {
        method: 'album.getinfo',
        api_key: API_KEY,
        mbid: payload.mbid,
        format: 'json'
      }
    }).then(function (response) {
      var trackList = response.data.album.tracks.track;

      state.tracks = trackList;
    }, function (response) {
      _this2.error = response.data;
    });
  },
  artistBio: function artistBio(state, payload) {
    var _this3 = this;

    state.bioContent = '';
    state.bio = [];
    state.bioImg = '';
    state.similarArtist = [];

    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('' + URL, {
      params: {
        method: 'artist.getinfo',
        api_key: API_KEY,
        artist: payload.name,
        autocorrect: 1,
        format: 'json'
      }
    }).then(function (response) {
      var bio = response.data.artist;
      var bioContent = bio.bio.content.replace(/(\r\n|\n|\r)/gm, '<br />');
      var bioImg = bio.image[3]['#text'];
      var similarArtist = bio.similar.artist;
      state.bioContent = bioContent;
      state.bio = bio;
      state.bioImg = bioImg;
      state.similarArtist = similarArtist;
    }, function (response) {
      _this3.error = response.data;
    });
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_store__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bio',
  mounted: function mounted() {
    var id = this.$route.params.id;
    __WEBPACK_IMPORTED_MODULE_0__data_store__["a" /* default */].dispatch('artistBio', {
      name: decodeURI(id)
    });
  },

  computed: {
    centerContent: function centerContent() {
      return __WEBPACK_IMPORTED_MODULE_0__data_store__["a" /* default */].state.similarArtist.length <= 0;
    }
  },
  methods: {
    newArtiest: function newArtiest(name) {
      __WEBPACK_IMPORTED_MODULE_0__data_store__["a" /* default */].dispatch('artistBio', {
        name: name
      });
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Search__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Search__);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'intro',
  components: {
    'search': __WEBPACK_IMPORTED_MODULE_0__components_Search___default.a
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_ScrollToPlugin__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap_ScrollToPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap_ScrollToPlugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tracks__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Tracks___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Tracks__);







var setCount = {
  count: 0
};
var audio = new Audio(),
    checkState = function checkState(currentIndex, v, i) {
  if (i !== currentIndex) {
    v.active = false;
  }
};
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'searchResults',
  components: {
    VuePerfectScrollbar: __WEBPACK_IMPORTED_MODULE_4_vue_perfect_scrollbar___default.a,
    'track-list': __WEBPACK_IMPORTED_MODULE_5__components_Tracks___default.a
  },
  data: function data() {
    return {
      settings: {
        maxScrollbarLength: 60
      }
    };
  },

  computed: {
    searchType: function searchType() {
      return __WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.searchType !== 'artist';
    }
  },
  mounted: function mounted() {
    this.tl = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({
      onComplete: this.dispalyResultsDone,
      paused: true
    });
    this.tlOut = new __WEBPACK_IMPORTED_MODULE_0_gsap__["TimelineMax"]({});
  },
  beforeUpdate: function beforeUpdate() {
    this.tl.clear();
    this.tlOut.clear();
  },

  methods: {
    toggleClass: function toggleClass(album, i) {
      if (__WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.searchType !== 'artist' && album.mbid !== '') {
        __WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.tracks = [];
        album.active = !album.active;
        __WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].dispatch('getTracks', {
          mbid: album.mbid,
          index: i
        });

        __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.forEach(__WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.searchResults, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.bind(checkState, this, i));
      }
    },
    dispalyResultsDone: function dispalyResultsDone() {
      setCount.count = 0;
    },
    enterEl: function enterEl(el) {
      setCount.count++;

      this.tl.fromTo(el, 0.5, {
        opacity: 0
      }, {
        opacity: 1,
        delay: .5
      }, 'searchResultsIn');

      if (setCount.count === __WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.total || setCount.count === __WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.limit) {
        if (__WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.offset > 0) {
          var offsetSong = document.querySelectorAll('.search-results').item(__WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.offset).offsetTop;

          this.tl.to(window, 0.5, {
            scrollTo: {
              y: offsetSong - 10
            },
            ease: __WEBPACK_IMPORTED_MODULE_0_gsap__["Power2"].easeInOut
          }, 'searchResultsIn');
        }

        this.tl.play();
      }
    },
    leaveEl: function leaveEl(el, done) {
      this.tlOut.to(el, .5, {
        opacity: 0,
        onComplete: done
      }, 'searchResultsOut');
    },
    loadMore: function loadMore() {
      __WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].dispatch('search', {
        tearm: __WEBPACK_IMPORTED_MODULE_2__data_store__["a" /* default */].state.searchTearm,
        type: 'loadMore'
      });
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Search_Results__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Search_Results___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Search_Results__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_store__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search',
  data: function data() {
    return {
      searchTearm: ''
    };
  },

  components: {
    'search-results': __WEBPACK_IMPORTED_MODULE_0__components_Search_Results___default.a
  },
  computed: {
    getSearchTearm: function getSearchTearm() {
      return 'Search for ' + __WEBPACK_IMPORTED_MODULE_1__data_store__["a" /* default */].state.searchType + 's';
    }
  },
  methods: {
    setSearchType: function setSearchType(event) {
      var currentVal = event.currentTarget.value;
      __WEBPACK_IMPORTED_MODULE_1__data_store__["a" /* default */].dispatch('setSearchType', {
        val: currentVal
      });
    },
    search: function search() {
      if (this.searchTearm !== "") {
        __WEBPACK_IMPORTED_MODULE_1__data_store__["a" /* default */].state.nextLink = 1;
        __WEBPACK_IMPORTED_MODULE_1__data_store__["a" /* default */].dispatch('search', {
          tearm: this.searchTearm,
          type: 'search'
        });
        this.searchTearm = '';
      }
    }
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'searchResults'
});

/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(50)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(61),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(47)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(58),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(51)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(63),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.searchTearm),
      expression: "searchTearm",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "search__search-input",
    attrs: {
      "type": "search",
      "name": "song search",
      "placeholder": _vm.getSearchTearm
    },
    domProps: {
      "value": (_vm.searchTearm)
    },
    on: {
      "change": function($event) {
        _vm.searchTearm = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "icon-magnifying_glass",
    attrs: {
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.search($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-types"
  }, [_vm._v("\n      Looking for:\n      "), _c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "search-type",
      "value": "album"
    },
    domProps: {
      "checked": _vm.$store.state.searchType === 'album'
    },
    on: {
      "change": _vm.setSearchType
    }
  }), _vm._v(" "), _c('span', [_vm._v("Albums")])]), _vm._v("\n      or\n      "), _c('label', [_c('input', {
    attrs: {
      "type": "radio",
      "name": "search-type",
      "value": "artist"
    },
    domProps: {
      "checked": _vm.$store.state.searchType === 'artist'
    },
    on: {
      "change": _vm.setSearchType
    }
  }), _vm._v(" "), _c('span', [_vm._v("Artists")])])])]), _vm._v(" "), _c('search-results')], 1)
},staticRenderFns: []}

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [(_vm.$store.state.total <= 0) ? _c('h1', {
    staticClass: "app__title"
  }, [_vm._v("Last FM Search")]) : _c('h1', [_vm._v(_vm._s(_vm.$store.state.total) + " Results for " + _vm._s(_vm.$store.state.searchTearm))]), _vm._v(" "), _c('search')], 1)
},staticRenderFns: []}

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bio"
  }, [_c('h2', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("\n      back to search\n    ")]), _vm._v("\n    " + _vm._s(_vm.$store.state.bio.name) + " Bio\n  ")], 1), _vm._v(" "), _c('p', {
    class: {
      'bio__content--center': _vm.centerContent
    }
  }, [(_vm.$store.state.bioImg !== '') ? _c('img', {
    staticClass: "bio__pick",
    attrs: {
      "src": _vm.$store.state.bioImg,
      "alt": _vm.$store.state.bio.name
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.bioContent)
    }
  })]), _vm._v(" "), (_vm.$store.state.similarArtist.length > 0) ? _c('aside', {
    staticClass: "similar"
  }, [_c('nav', [_c('h3', [_vm._v("Also Check out:")]), _vm._v(" "), _vm._l((_vm.$store.state.similarArtist), function(similar) {
    return _c('div', {
      on: {
        "click": function($event) {
          _vm.newArtiest(similar.name)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": ("/bio/" + (encodeURI(similar.name)))
      }
    }, [_c('img', {
      attrs: {
        "src": similar.image[3]['#text'],
        "alt": similar.name
      }
    })])], 1)
  })], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results-holder"
  }, [_c('transition-group', {
    attrs: {
      "css": false
    },
    on: {
      "afterEnter": _vm.enterEl,
      "leave": _vm.leaveEl
    }
  }, _vm._l((_vm.$store.state.searchResults), function(searchResults, searchResultsIndex) {
    return _c('div', {
      key: searchResults.name + searchResults.artist,
      staticClass: "search-results",
      class: {
        'search-results--active': searchResults.active, 'search-results__album': searchResults.mbid !== '' ? _vm.searchType : ''
      },
      on: {
        "click": function($event) {
          _vm.toggleClass(searchResults, searchResultsIndex)
        }
      }
    }, [(_vm.$store.state.searchType === 'artist') ? _c('router-link', {
      attrs: {
        "to": ("/bio/" + (encodeURI(searchResults.name)))
      }
    }, [_c('p', {
      staticClass: "search-results__name"
    }, [_vm._v(_vm._s(searchResults.name))]), _vm._v(" "), (searchResults.image[3]['#text'] !== '') ? _c('img', {
      attrs: {
        "src": searchResults.image[3]['#text']
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(14)
      }
    })]) : _c('div', {
      staticClass: "search-results__album"
    }, [_c('p', {
      staticClass: "search-results__name"
    }, [_vm._v(_vm._s(searchResults.name))]), _vm._v(" "), (searchResults.image[3]['#text'] !== '') ? _c('img', {
      attrs: {
        "src": searchResults.image[3]['#text']
      }
    }) : _c('img', {
      attrs: {
        "src": __webpack_require__(14)
      }
    })]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "show-tracks"
      }
    }, [(searchResults.active) ? _c('div', {
      staticClass: "tracks-holder"
    }, [_c('h3', [_vm._v(_vm._s(searchResults.name))]), _vm._v(" "), _vm._o(_c('VuePerfectScrollbar', {
      staticClass: "scroll-area",
      attrs: {
        "settings": _vm.settings
      }
    }, [_c('track-list')], 1), 0, searchResults.name + searchResults.artist)], 1) : _vm._e()])], 1)
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-in"
    }
  }, [(_vm.$store.state.nextLink > 1) ? _c('button', {
    staticClass: "search-results-holder__load-more",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("Load More")]) : _vm._e()]), _vm._v(" "), (_vm.$store.state.noResults) ? _c('p', {
    staticClass: "search-resultss-holder__sorry-message"
  }, [_vm._v("\n    Sorry no results for "), _c('span', [_vm._v(_vm._s(_vm.$store.state.searchTearm))]), _vm._v("!\n  ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "track-list"
  }, _vm._l((_vm.$store.state.tracks), function(track) {
    return _c('li', {
      key: track.name
    }, [_c('a', {
      attrs: {
        "href": track.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(track.name))])])
  }))
},staticRenderFns: []}

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[38]);


// WEBPACK FOOTER //
// static/js/app.fa3efc96211d7f6fa920.js